import React, { useState, useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import SummaryApi from "../common";

const InstructorProtectedRoute = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const location = useLocation();
  const instructorId = sessionStorage.getItem("instructor_id");
  const loginIdentifier = sessionStorage.getItem("login_identifier");
  const sessionToken = sessionStorage.getItem("H7Z4L9VD2XK5JW8QRYT6");

  useEffect(() => {
    const verifySession = async () => {
      // Allow edit-instructor page right after OTP
      if (location.pathname.includes("/instructor-panel/edit-instructor") && instructorId && sessionToken) {
        setIsAuthenticated(true);
        return;
      }

      if (!instructorId || !loginIdentifier || !sessionToken) {
        setIsAuthenticated(false);
        return;
      }

      try {
        const response = await fetch(SummaryApi.instructorLoginStatus.url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ login_identifier: loginIdentifier }),
        });

        const data = await response.json();

        if (data.status && data.data?.is_active === 1 && data.data?.is_otp_verification === 1) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
          sessionStorage.clear();
          toast.error("Session expired or invalid. Please log in again.");
        }
      } catch (error) {
        console.error("Protected route error:", error);
        setIsAuthenticated(false);
        sessionStorage.clear();
        toast.error("Error verifying session. Please log in again.");
      }
    };

    verifySession();
  }, [instructorId, loginIdentifier, sessionToken, location.pathname]);

  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Verifying session...</p>
        </div>
      </div>
    );
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/instructor-login" state={{ from: location }} replace />;
};

export default InstructorProtectedRoute;